import { ControlProps, JsonFormsRendererRegistryEntry } from '@jsonforms/core';
import {
  withJsonFormsControlProps,
  withJsonFormsEnumProps,
  withJsonFormsOneOfEnumProps,
  withTranslateProps,
} from '@jsonforms/react';
import merge from 'lodash.merge';
import React, { useState } from 'react';
import * as MaterialRenderers from '@jsonforms/material-renderers';

export interface WithWrappedControl {
  wrappedControl: any;
}

export type ControlWithTouchedProps = ControlProps & WithWrappedControl;

function ControlWithTouched(props: ControlWithTouchedProps) {
  const [touched, setTouched] = useState(false);
  const WrappedControl = props.wrappedControl;
  return (
    <div onBlur={() => setTouched(true)} style={{ padding: 4 }}>
      <WrappedControl {...unwrapProps(props, touched)} />
    </div>
  );
}

function unwrapProps(props: ControlWithTouchedProps, touched: boolean) {
  const { errors, config, uischema } = props;
  const { forceShow } = merge({}, config, uischema.options);
  const showErrors = touched || forceShow;
  const result = { ...props, errors: showErrors ? errors : '' };
  delete result.wrappedControl;
  return result;
}

export const wrapperFunctions: Record<string, any> = {
  MaterialEnumControl: (c: any) => withJsonFormsEnumProps(c, false),
  MaterialOneOfEnumControl: (c: any) =>
    withJsonFormsOneOfEnumProps(withTranslateProps(React.memo(c)), false),
  MaterialOneOfRadioGroupControl: (c: any) => withJsonFormsOneOfEnumProps(c),
};

export function wrapRendererRegistry(
  entry: JsonFormsRendererRegistryEntry
): JsonFormsRendererRegistryEntry {
  const tester = entry.tester;
  let renderer = entry.renderer;
  Object.entries(MaterialRenderers.Unwrapped).some(([key, wrappedControl]) => {
    const otherTester = (MaterialRenderers as Record<string, any>)[`m${key.substring(1)}Tester`];
    if (key === 'MaterialEnumArrayRenderer') {
      return false;
    }
    const match = tester === otherTester;
    if (match) {
      const wrapperFunction = wrapperFunctions[key] || withJsonFormsControlProps;
      renderer = wrapperFunction((props: any) => (
        <ControlWithTouched {...{ ...props, wrappedControl }} />
      ));
    }
    return match;
  });
  return { renderer, tester };
}

export const materialRenderers = MaterialRenderers.materialRenderers.map(wrapRendererRegistry);
export const materialCells = MaterialRenderers.materialCells;
